export const disabledAutoFocusMenuProps = {
  disableAutoFocus: true,
  autoFocus: false,
};
